import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=443b2766&scoped=true"
import script from "./no-content.vue?vue&type=script&lang=js"
export * from "./no-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b2766",
  null
  
)

export default component.exports